import { styled, component } from '../../../utils/style';
import { Format } from '../../../utils/styles-constants';

export const BreadcrumbThread = styled()(component.div, 'BreadcrumbThread')`
	padding: 9px 14px;
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	line-height: 30px;

	& > * {
		color: ${props => props.theme.primary.strongColor};
		text-decoration: none;
	}

	& > a {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		@media ${Format.Smartphone} {
			max-width: 70px;
		}

		@media ${Format.Tablet} {
			max-width: 200px;
		}

	}

	& > span {
		font-weight: 500;
	}

	& > svg {
		height: 30px;
		width: 30px;
		fill: ${props => props.theme.primary.strongColor};
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/Breadcrumbs/styles.ts